// import React, { useState, useMemo } from "react";
// import { Card, Statistic, Segmented, Row, Col, Spin } from "antd";
// import SectionHeader from "../components/commons/SectionHeader";
// import QurealSection from "../common/QurealSection";
// import { useItemsFine } from "../actions/app/items";
// import dayjs from "dayjs";
// import styles from "./styles/DashboardDesign.module.css";

// function DashboardDesign() {
//   const [timeframe, setTimeframe] = useState("Today");

//   const dateFilter = useMemo(() => {
//     const today = dayjs();
//     switch (timeframe) {
//       case "Today":
//         return `filter[date_created][_between]=${today.startOf("day").toISOString()},${today.endOf("day").toISOString()}`;
//       case "Yesterday":
//         const yest = today.subtract(1, "day");
//         return `filter[date_created][_between]=${yest.startOf("day").toISOString()},${yest.endOf("day").toISOString()}`;
//       case "Last 7 Days":
//         return `filter[date_created][_gte]=${today.subtract(6, "day").startOf("day").toISOString()}`;
//       case "This Month":
//         return `filter[date_created][_gte]=${today.startOf("month").toISOString()}`;
//       case "Last Month":
//         const lastMonthStart = today.subtract(1, "month").startOf("month");
//         const lastMonthEnd = today.subtract(1, "month").endOf("month");
//         return `filter[date_created][_between]=${lastMonthStart.toISOString()},${lastMonthEnd.toISOString()}`;
//       default:
//         return "";
//     }
//   }, [timeframe]);

//   const { isLoading: loadingCr, data: dataCr } = useItemsFine(
//     "qp_creation",
//     `meta=*&${dateFilter}`,
//     true,
//     false,
//     true
//   );

//   const { isLoading: loadingCrt, data: dataCrt } = useItemsFine(
//     "qdb_creation_template",
//     `meta=*&${dateFilter}`,
//     true,
//     false,
//     true
//   );

//   const countCr = dataCr?.meta?.filter_count ?? 0;
//   const countCrt = dataCrt?.meta?.filter_count ?? 0;

//   return (
//     <QurealSection
//       header={
//         <SectionHeader heading="Design Dashboard">
//           <Segmented
//             options={[
//               "Today",
//               "Yesterday",
//               "Last 7 Days",
//               "This Month",
//               "Last Month",
//             ]}
//             value={timeframe}
//             onChange={(val) => setTimeframe(val)}
//           />
//         </SectionHeader>
//       }
//     >
//       <div className={styles.wrapper}>
//         <Row gutter={16}>
//           <Col span={12}>
//             <Card>
//               {loadingCr ? (
//                 <Spin />
//               ) : (
//                 <Statistic title="New Designs Created" value={countCr} />
//               )}
//             </Card>
//           </Col>
//           <Col span={12}>
//             <Card>
//               {loadingCrt ? (
//                 <Spin />
//               ) : (
//                 <Statistic title="New Templates Published" value={countCrt} />
//               )}
//             </Card>
//           </Col>
//         </Row>
//       </div>
//     </QurealSection>
//   );
// }

// export default DashboardDesign;

import React, { useState, useMemo } from "react";
import { Card, Statistic, Select, Row, Col, Spin } from "antd";
import SectionHeader from "../components/commons/SectionHeader";
import QurealSection from "../common/QurealSection";
import { useItemsFine } from "../actions/app/items";
import dayjs from "dayjs";
import styles from "./styles/DashboardDesign.module.css";

function DashboardDesign() {
    const [timeframe, setTimeframe] = useState("Today");

    const dateFilter = useMemo(() => {
        const today = dayjs();
        switch (timeframe) {
            case "Today":
                return `filter[date_created][_between]=${today
                    .startOf("day")
                    .toISOString()},${today.endOf("day").toISOString()}`;
            case "Yesterday":
                const yest = today.subtract(1, "day");
                return `filter[date_created][_between]=${yest
                    .startOf("day")
                    .toISOString()},${yest.endOf("day").toISOString()}`;
            case "Last 7 Days":
                return `filter[date_created][_gte]=${today
                    .subtract(6, "day")
                    .startOf("day")
                    .toISOString()}`;
            case "This Month":
                return `filter[date_created][_gte]=${today
                    .startOf("month")
                    .toISOString()}`;
            case "Last Month":
                const lastMonthStart = today
                    .subtract(1, "month")
                    .startOf("month");
                const lastMonthEnd = today.subtract(1, "month").endOf("month");
                return `filter[date_created][_between]=${lastMonthStart.toISOString()},${lastMonthEnd.toISOString()}`;
            default:
                return "";
        }
    }, [timeframe]);

    // ✅ Only fetch `date_created` + `meta[filter_count]`
    const { isLoading: loadingCr, data: dataCr } = useItemsFine(
        "qp_creation",
        `fields=date_created&meta=filter_count&${dateFilter}`,
        true,
        false,
        true
    );

    const { isLoading: loadingCrt, data: dataCrt } = useItemsFine(
        "qdb_creation_template",
        `fields=date_created&meta=filter_count&${dateFilter}`,
        true,
        false,
        true
    );

    const countCr = dataCr?.meta?.filter_count ?? 0;
    const countCrt = dataCrt?.meta?.filter_count ?? 0;

    return (
        <QurealSection
            header={
                <SectionHeader heading="Design Dashboard">
                    <Select
                        value={timeframe}
                        onChange={(val) => setTimeframe(val)}
                        style={{ width: 200 }}
                        options={[
                            { label: "Today", value: "Today" },
                            { label: "Yesterday", value: "Yesterday" },
                            { label: "Last 7 Days", value: "Last 7 Days" },
                            { label: "This Month", value: "This Month" },
                            { label: "Last Month", value: "Last Month" },
                        ]}
                    />
                </SectionHeader>
            }
        >
            <div className={styles.wrapper}>
                <Row gutter={16}>
                    <Col span={12}>
                        <Card>
                            {loadingCr ? (
                                <Spin />
                            ) : (
                                <Statistic
                                    title="New Designs Created"
                                    value={countCr}
                                />
                            )}
                        </Card>
                    </Col>
                    <Col span={12}>
                        <Card>
                            {loadingCrt ? (
                                <Spin />
                            ) : (
                                <Statistic
                                    title="New Templates Published"
                                    value={countCrt}
                                />
                            )}
                        </Card>
                    </Col>
                </Row>
            </div>
        </QurealSection>
    );
}

export default DashboardDesign;
